import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

export const defaultGuard = () => {
	const sessionService: SessionService = inject(SessionService);
	const router: Router = inject(Router);

	if (sessionService.defaultRoute) {
		return new RedirectCommand(
			router.createUrlTree(sessionService.getLink(sessionService.defaultRoute.route)),
			{ replaceUrl: true, skipLocationChange: false }
		);
	} else if (sessionService.defaults.isManager && sessionService.hasAccess('ph-plan', ['edit', 'view'])) {
		return new RedirectCommand(
			router.createUrlTree(sessionService.getLink('plan')),
			{ replaceUrl: true, skipLocationChange: false }
		);
	} else {
		return true;
	}
}
